export class CMath {
    public linearTween: Function;
    public easeInQuad: Function;
    public easeOutQuad: Function;
    public easeInOutQuad: Function;
    public easeInCubic: Function;
    public easeOutCubic: Function;
    public easeInOutCubic: Function;
    public easeInQuart: Function;
    public easeOutQuart: Function;
    public easeInOutQuart: Function;
    public easeInQuint: Function;
    public easeOutQuint: Function;
    public easeInOutQuint: Function;
    public easeInSine: Function;
    public easeOutSine: Function;
    public easeInOutSine: Function;
    public easeInExpo: Function;
    public easeOutExpo: Function;
    public easeInOutExpo: Function;
    public easeInCirc: Function;
    public easeOutCirc: Function;
    public easeInOutCirc: Function;
}
